import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPersonDestructive(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 177 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_734_24627)">
        <circle cx="88.5" cy="60" r="50" stroke="url(#paint0_linear_734_24627)" strokeWidth="20" />
      </g>
      <path
        d="M78.163 71.2851L77.5909 71.7592L78.163 71.2851C77.4303 70.401 77.1617 69.2153 77.6925 68.0072C79.5842 63.7018 83.4818 60.75 88.4983 60.75C93.5148 60.75 97.4125 63.7018 99.3042 68.0072C99.835 69.2153 99.5664 70.401 98.8337 71.2851C98.1016 72.1686 96.9066 72.75 95.5862 72.75H81.4105C80.0901 72.75 78.8951 72.1686 78.163 71.2851ZM82.5 51.75C82.5 48.4363 85.1863 45.75 88.5 45.75C91.8137 45.75 94.5 48.4363 94.5 51.75C94.5 55.0637 91.8137 57.75 88.5 57.75C85.1863 57.75 82.5 55.0637 82.5 51.75Z"
        stroke="#0C1C43"
        strokeWidth="1.5"
      />
      <rect x="34.6113" y="7.5" width="39" height="39" rx="19.5" fill="#B01921" />
      <rect x="34.6113" y="7.5" width="39" height="39" rx="19.5" stroke="white" />
      <path d="M49 22L59 32M59 22L49 32" stroke="white" strokeLinecap="round" />
      <defs>
        <linearGradient
          id="paint0_linear_734_24627"
          x1="88.5"
          y1="10"
          x2="88.0699"
          y2="85.5332"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#F9E1E1" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="clip0_734_24627">
          <rect x="38.5" y="10" width="100" height="100" rx="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPersonDestructive);
export default ForwardRef;
